import React from 'react';
import { Box, TextInput, Button, Text, Layer } from 'grommet';
import { Close } from 'grommet-icons';
import Divider from 'granite-admin/core/components/Divider';
import FormField from 'granite-admin/core/components/FormField';
import { Formik } from 'formik';
import * as Yup from 'yup';
const InviteUserLayer = ({
  setLayer,
  changeEmail,
  userInvitation,
  eventEmitter
}) => {
  const validationSchema = Yup.object().shape({
    email: Yup.string().min(2, 'Email too short').max(50, 'Email too long').email('Please enter valid email').required('Confirm email is required'),
    name: Yup.string().required('name is required')
  });
  const onSubmit = async (values, {
    setSubmitting,
    setErrors
  }) => {
    setErrors({});
    setSubmitting(true);
    try {
      await userInvitation(eventEmitter, values);
      setSubmitting(false);
      setLayer(false);
      // await changeEmail(eventEmitter, values)
    } catch (e) {
      if (e.errors) setErrors(e.errors);
      setSubmitting(false);
    }
  };
  return /*#__PURE__*/React.createElement(Layer, {
    position: "center",
    onClickOutside: () => setLayer(false),
    onEsc: () => setLayer(false)
  }, /*#__PURE__*/React.createElement(Box, {
    background: "white",
    gap: "small",
    width: "38rem"
  }, /*#__PURE__*/React.createElement(Box, {
    justify: "between",
    direction: "row",
    pad: {
      top: 'medium',
      left: 'medium',
      right: 'medium',
      bottom: 'small'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "21px"
  }, "Invite User"), /*#__PURE__*/React.createElement(Box, {
    onClick: () => setLayer(false),
    pad: {
      top: 'xsmall'
    }
  }, /*#__PURE__*/React.createElement(Close, {
    size: "20px"
  }))), /*#__PURE__*/React.createElement(Divider, {
    color: "brand"
  }), /*#__PURE__*/React.createElement(Box, {
    pad: {
      top: 'medium',
      left: 'large',
      right: 'large',
      bottom: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Formik, {
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    initialValues: {
      password: '',
      new_email: '',
      email: '',
      name: ''
    }
  }, ({
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue
  }) => /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    autocomplete: "off"
  }, /*#__PURE__*/React.createElement("input", {
    autocomplete: "new-password",
    name: "hidden",
    type: "password",
    style: {
      display: 'none'
    }
  }), /*#__PURE__*/React.createElement(Box, {
    margin: {
      bottom: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    size: "10px"
  }, "Invite a new user to this platform."), ' '), /*#__PURE__*/React.createElement(FormField, {
    name: "email",
    label: "Email Address",
    error: touched.email && errors.email,
    width: "70%"
  }, /*#__PURE__*/React.createElement(TextInput, {
    name: "email",
    autocomplete: "new-password",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.email
  })), /*#__PURE__*/React.createElement(FormField, {
    name: "name",
    label: "Name",
    error: touched.name && errors.name,
    width: "70%"
  }, /*#__PURE__*/React.createElement(TextInput, {
    name: "name",
    autocomplete: "new-password",
    onChange: handleChange,
    onBlur: handleBlur,
    value: values.name
  })), /*#__PURE__*/React.createElement(Box, {
    as: "footer",
    gap: "small",
    direction: "row",
    align: "center",
    justify: "end",
    pad: {
      top: 'medium',
      bottom: 'small'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    alignSelf: "end",
    margin: {
      vertical: 'small'
    },
    label: "Go On",
    primary: true,
    disabled: isSubmitting
  })))))));
};
export default InviteUserLayer;